import { apiClient, handleResp } from './utils';

export default {
  getCategories(params = {}) {
    return handleResp(apiClient({ apiVer: 2 }).get('/product_categories', { params }));
  },
  getProducts(params = {}) {
    return handleResp(apiClient({ apiVer: 2 }).get('/products', { params }));
  },
  getProduct(id) {
    return handleResp(apiClient({ apiVer: 2 }).get('/products/' + id));
  },
  doCheckout(id, quantity, coupon) {
    return handleResp(apiClient({ apiVer: 2 }).post('/products/checkout', { id, quantity, coupon }));
  },
};
